import RiUserFollowLine from '@ben/icons/user-follow-line';
import RiUserUnfollowLine from '@ben/icons/user-unfollow-line';
import RIcon from '@ben/orion/remix-icon';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { useTranslation } from 'react-i18next';
import styled, { css, useTheme } from 'styled-components';

interface VisibilityInformationProps {
  isPolicyDocument?: boolean;
}

const VisibilityInformation = ({
  isPolicyDocument,
}: VisibilityInformationProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <VisibilityContainer
      variant={TypographyVariant.bodySm1}
      color={theme.palette.neutral[80]}
    >
      <RIcon
        icon={isPolicyDocument ? RiUserUnfollowLine : RiUserFollowLine}
        size="xs"
        color={theme.palette.neutral[70]}
      />
      {isPolicyDocument
        ? t('documents.hiddenFromEmployees')
        : t('documents.visibleToEmployees')}
    </VisibilityContainer>
  );
};

export default VisibilityInformation;

const VisibilityContainer = styled(Typography)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(0.5)};
    align-items: center;
  `}
`;
